import ActionTypes from "../../../constants/ActionTypes";
import { ISectionState, ISetSectionAction } from "./types";

export function setActiveSection(section: ISectionState): ISetSectionAction {
  return {
    type: ActionTypes.SECTION.SET,
    payload: section,
  };
}
